var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0"},[_c('HotelForm',{attrs:{"owner-creation-form":"","dialog-data":_vm.dialogData,"initial-filled-data":_vm.hotelFormInitialFilledData},on:{"update:dialogData":function($event){_vm.dialogData=$event},"update:dialog-data":function($event){_vm.dialogData=$event},"finish":_vm.finish}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }